import Model from './model.js'
import Deal from './deal.js'
import Contact from './contact.js'

export default class Note extends Model {
	static _routeKey = 'note'
	static _attributes = {
		belongs_id: null,
		belongs_type: null,
		description: '',
	}

	_tailIgnore = [
		'_tailIgnore',
		'tailIgnore',
		'tail',
		'vue',
		'created_at',
		'updated_at',
		'id',
		'belongs_type',
		'$help',
		'$log',
		'user_id',
		'publishedStates',
	]

	publishedStates = ['draft', 'sent']

	tail = {
		description: () => ['note', this.description],
		belongs_id: () => ['Associated deal', parseInt(this.belongs_type) != 102 ? this.belongs_id : 'No deal associated'],
		createdDescription: () => '"' + this.description + '" was created',
	}

	_logIcon() {
		return 'IconNoteDraftCircle'
	}

	// tailSingleDescriptions = {

	// }

	timeline(user) {
		let t = this._timeline(user)
		let l = this.level('deal')

		return {
			title: this.published_at == null ? this.created_by.first_name + ' created a draft' : this.created_by.first_name + ' created a note',
			description: this.description,
			created_at: this.created_at,
			icon: this.published_at == null ? 'IconNoteDraftCircle' : 'IconNoteCircle',
			breakdown: {
				Note: this.description,
				'Linked deal':
					l == false
						? null
						: {
								type: 'NuxtLink',
								to: l.link,
								text: l.title,
						  },
			},
			options: {
				Edit: () => this.edit(),
				Delete: () => this.destroy(),
			},
		}
	}

	destroy(emit = 'timeline-deleted') {
		this.vue.$event.$emit('modal-open', {
			view: 'Confirm',
			options: {
				action: '/note/' + this.id,
				message: 'Are you sure you want to delete this note?',
				button: 'Delete',
				method: 'DELETE',
				head: 'Delete note',
			},
		})

		// this.vue.$axios.delete('/'+this._type()+'/'+this.id)
		//     .then(res => {
		//         this.vue.$event.$emit(emit)
		//     })
	}

	edit() {
		this.vue.$event.$emit('modal-open', {
			view: 'Note',
			editingModel: this,
			modelId: this.belongs_id,
			modelType: this.belongs_type,
			options: {
				note: this,
			},
		})
	}

	level(only = null) {
		if (this.belongs_type !== undefined && this.belongs != null) {
			let title = ''
			let link = ''
			let data = null

			switch (true) {
				case this.vue.$help.idName(this.belongs_type) == 'deal':
					link = '/deal/' + this.belongs_id

					data = new Deal(this.belongs)

					title = data.getName()
					break

				case this.vue.$help.idName(this.belongs_type) == 'contact' && only == null:
					data = new Contact(this.belongs)

					title = data.fullName()

					link = '/contact/' + this.belongs_id
					break
				default:
					return false
			}

			return {
				model: this.vue.$help.idName(this.belongs_type),
				data: data,
				title: title,
				link: link,
			}
		}

		return false
	}
}
